<p>error-page works!</p>
<button (click)="onSignOutClick()">SignOut</button>
